import getAuth0 from '.'

export default async function handleCallback(): Promise<void> {
  const auth0 = getAuth0()
  try {
    await auth0.handleRedirectCallback()
  } catch (error) {
    if (error.message !== 'Invalid state') throw error
    try {
      await auth0.getTokenSilently()
    } catch (e) {
      throw error
    }
  }
}
